import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AlertCircleFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.99998 1.33337C11.6819 1.33337 14.6666 4.31814 14.6666 8.00004C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00004C1.33331 4.31814 4.31808 1.33337 7.99998 1.33337ZM7.99998 9.66671C7.53972 9.66671 7.16665 10.0398 7.16665 10.5C7.16665 10.9603 7.53972 11.3334 7.99998 11.3334C8.46024 11.3334 8.83331 10.9603 8.83331 10.5C8.83331 10.0398 8.46024 9.66671 7.99998 9.66671ZM7.99998 4.66671C7.63179 4.66671 7.33331 4.96518 7.33331 5.33337V8.00004C7.33331 8.36823 7.63179 8.66671 7.99998 8.66671C8.36817 8.66671 8.66665 8.36823 8.66665 8.00004V5.33337C8.66665 4.96518 8.36817 4.66671 7.99998 4.66671Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AlertCircleFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AlertCircleFilledIcon;
